export class FontFamily {
  static default = '"Rubik", sans-serif';
}

export class FontWeight {
  static light = 300;
  static regular = 400;
  static medium = 500;
  static semiBold = 600;
  static bold = 700;
}

export class FontSize {
  static s8 = '8px';
  static s9 = '9px';
  static s10 = '10px';
  static s12 = '12px';
  static s14 = '14px';
  static s16 = '16px';
  static s18 = '18px';
  static s24 = '24px';
  static s28 = '28px';
  static s32 = '32px';
  static s36 = '36px';
  static s48 = '48px';
}
